<div class="slider-container">
    <div style="display: flex; gap: 10px; flex-grow: 1;">
        <div style="position: relative; flex-grow: 1;">
            <div class="limit-label" style="left: 5px;">{{lowerLimit()}}</div>
            
            <ng-container #sliderTemplateContainer [ngTemplateOutlet]="sliderTemplate"></ng-container>
            <ng-template #sliderTemplate>
                <nz-slider [nzMin]="lowerLimit()" [nzMax]="upperLimit()" [ngModel]="value()" (nzOnAfterChange)="onSliderChange($event)">
                </nz-slider>
            </ng-template>

            <div class="limit-label" style="right: 5px;">{{ upperLimit() }}</div>
        </div>

        @if (!isMobile()) {
            <div>
                <nz-input-number 
                    [nzMin]="lowerLimit()" 
                    [nzMax]="upperLimit()" 
                    [(ngModel)]="value" 
                    (change)="onInputEnter()"
                    (keyup.arrowdown)="onInputArrow()"
                    (keyup.arrowup)="onInputArrow()"
                >
                </nz-input-number>
            </div>

            <div class="step-controls">
                <span class="step-label">Step:</span>
                <nz-input-number [(ngModel)]="stepValue" [nzMin]="1" class="step-input"></nz-input-number>

                <button class="step-change" nzType="default" (click)="adjustStep('minus')">
                    <span nz-icon nzType="minus"></span>
                </button>
                <button class="step-change" nzType="default" (click)="adjustStep('plus')">
                    <span nz-icon nzType="plus"></span>
                </button>
            </div>
        }
    </div>
</div>